import script from "./FeatureBreakdown.vue?vue&type=script&setup=true&lang=js"
export * from "./FeatureBreakdown.vue?vue&type=script&setup=true&lang=js"

import "./FeatureBreakdown.vue?vue&type=style&index=0&id=ec646450&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ec646450"]])

export default __exports__